var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstacollect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.47,
    x2: 0.5,
    y2: 1.285,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "InstaCollect",
    transform: "translate(-432 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6099",
    "data-name": "Rectangle 6099",
    width: 24,
    height: 24,
    transform: "translate(432 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "instacollect-2",
    "data-name": "instacollect",
    transform: "translate(438.24 57.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M10.156,0H1.364A1.321,1.321,0,0,0,0,1.274V17.926A1.321,1.321,0,0,0,1.364,19.2h8.793a1.321,1.321,0,0,0,1.364-1.274V1.274A1.321,1.321,0,0,0,10.156,0Z",
    transform: "translate(0 0)",
    fill: "#120d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M10.575,1H1.025A.025.025,0,0,0,1,1.026V18.254a.025.025,0,0,0,.025.026h9.55a.025.025,0,0,0,.025-.026V1.026A.025.025,0,0,0,10.575,1Z",
    transform: "translate(-0.04 -0.04)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M7.4.36H4.784A.136.136,0,0,0,4.648.5V.523a.136.136,0,0,0,.136.136H7.4A.136.136,0,0,0,7.536.523V.5A.136.136,0,0,0,7.4.36Z",
    transform: "translate(-0.186 -0.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M6.013,13.36a3.68,3.68,0,1,0-3.68-3.68A3.68,3.68,0,0,0,6.013,13.36Z",
    transform: "translate(-0.093 -0.24)",
    fill: "#33eeb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M6.5,8.988H4.72a.247.247,0,0,1-.23-.23.211.211,0,0,1,.23-.23H6.5c0-.058-.057-.115-.057-.173a.867.867,0,0,0-.805-.518H4.777a.436.436,0,0,1-.23-.115c-.115-.115,0-.345.173-.345H7.307a.211.211,0,0,1,.23.23.247.247,0,0,1-.23.23H6.675a3.082,3.082,0,0,1,.288.633h.345a.263.263,0,0,1,.288.23.247.247,0,0,1-.23.23H7.02a1.4,1.4,0,0,1-1.668,1.092l.115.115c.46.46.92.862,1.38,1.322l.115.115a.257.257,0,0,1,0,.288.19.19,0,0,1-.288,0c-.058,0-.058-.058-.115-.058-.633-.575-1.265-1.207-1.84-1.783C4.6,9.908,4.547,9.85,4.6,9.678c.058-.115.173-.115.288-.115h.863A.692.692,0,0,0,6.5,8.988Z",
    transform: "translate(-0.18 -0.295)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstacollect);
export default __webpack_public_path__ + "static/media/instacollect.0c91b08226833b39b3318f26b7dccf9e.svg";
export { ForwardRef as ReactComponent };